import { RubricaeService } from './rubricaeService';

export class grafSignService {
    static async addSign(body: any): Promise<any> {
        const response = await RubricaeService.post(`/user/graphometric-signatures`, body);
        return response.data;
    }

    static async updateSign(id: string, body: any) {
        const response = await RubricaeService.put(`/user/graphometric-signatures/${id}`, body);
        return response.data;
    }

    static async getSigns(): Promise<any> {
        const response = await RubricaeService.get(`/user/graphometric-signatures`);
        return response.data;
    }
}
